import React from "react";
import { CopilotWithoutTailwind as CopilotWithOutAnimation } from "./copilot";
import { useRouter } from "next/router";
import { useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { tapBtnCallScheduled } from "segments/eventActions/common/callBackModule";
import { journeyEnum } from "@utils/journeyEnum";
import { getJourneyFromPath } from "@utils/productEnum";
import { CHAT_FAB_Z_INDEX } from "@utils/uiZIndex";

const ALLOWED_PATHS: string[] = [
  "gi/bike-journey/plans",
  "gi/bike-journey/plan-details",
  "gi/bike-journey/checkout/review",
  "gi/bike-journey/plans",
  "gi/bike-journey/plan-details",
  "gi/bike-journey/checkout/review",
  "gi/new-car/plans",
  "gi/new-car/plan-details/addons",
  "gi/new-car/plan-details/addons",
  "gi/new-car/checkout/review"
];

const Chatbot = () => {
  const { asPath, query } = useRouter();
  const dispatch = useDispatch();
  const currentPath = asPath ? asPath.split(/[?#]/)[0] : "";

  const copilotEventHandler = (e: any) => {
    switch (e.data.type) {
      case "copilot-iframe-loaded":
        break;

      case "copilot-agent-callback-init":
        break;

      case "join-conversation":
        break;

      case "copilot-agent-callback-success":
        const journey =
          (typeof window !== "undefined" &&
            journeyEnum[window.product as keyof typeof journeyEnum]) ||
          getJourneyFromPath(currentPath, {
            flow: query?.flow as string | undefined,
            product: query?.product as string | undefined
          }) ||
          undefined;
        dispatch(
          tapBtnCallScheduled({
            edata: {
              language: e?.data?.payload?.preferred_language,
              phone: e?.data?.payload?.phoneNumber
            },
            odata: {
              journey
            }
          })
        );
        break;

      case "copilot-iframe-open":
        break;

      case "copilot-iframe-close":
        break;

      default:
    }
  };
  const isCopilotEnabled = useMemo(() => {
    if (!currentPath) return false;
    return ALLOWED_PATHS.some(path => currentPath.includes(path));
  }, [currentPath]);

  const chatbotUrl = useMemo(() => {
    const baseUrl = process.env.HOST_URL || "https://www.acko.com";
    const host = baseUrl.replace(/^https?:\/\//, "").replace(/\/$/, "");
    let scope = "fresh-bike";
    if (currentPath.includes("bike-journey")) {
      scope = query?.flow === "new" ? "new-bike" : "fresh-bike";
    } else if (currentPath.includes("new-car")) {
      scope = "auto-newcar";
    }
    const callButtonParam = currentPath.includes("car")
      ? "&call_button=true"
      : "";
    return `https://${host}/p/acko-assist-v2/chat?journey=auto-presales&scope=${scope}${callButtonParam}`;
  }, [currentPath, query?.flow]);

  useEffect(() => {
    window.addEventListener("message", copilotEventHandler);
    return () => {
      window.removeEventListener("message", copilotEventHandler);
    };
  }, []);

  return isCopilotEnabled ? (
    <CopilotWithOutAnimation
      url={chatbotUrl}
      fabHide={false}
      onEvent={() => {}}
      zIndex={CHAT_FAB_Z_INDEX}
      bottom={120}
    />
  ) : null;
};

export default Chatbot;